import {
  DeleteObjectCommand,
  GetObjectCommand,
  PutObjectCommand,
  S3Client
} from '@aws-sdk/client-s3'

const AWS_REGION = process.env.REACT_APP_AWS_REGION
const AWS_STORAGE_IMG_BUCKET = process.env.REACT_APP_AWS_STORAGE_IMG_BUCKET
const AWS_ACCESS_KEY_ID = process.env.REACT_APP_AWS_ACCESS_KEY_ID
const AWS_SECRET_ACCESS_KEY = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY

const s3Client = new S3Client({
  region: AWS_REGION,
  credentials: {
    accessKeyId: AWS_ACCESS_KEY_ID!,
    secretAccessKey: AWS_SECRET_ACCESS_KEY!
  }
})

const dataUrlToBytes = (dataUrl: string) => {
  const [meta, base64] = dataUrl.split(',')
  const mime = meta.match(/:(.*?);/)?.[1]

  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }

  return { bytes, mime }
}

export const uploadThumbnail = async (dataUrl: string, formId: string) => {
  const { bytes, mime } = dataUrlToBytes(dataUrl)

  if (mime) {
    const mimeExt = mime.split('/')?.[1]
    const thumbnailKey = `${formId}/thumbnail.${mimeExt}`

    await uploadObject(thumbnailKey, bytes, mime)
  }
}

const uploadObject = async (key: string, bytes: any, mime: string) => {
  try {
    const uploadRes = await s3Client.send(
      new PutObjectCommand({
        Bucket: AWS_STORAGE_IMG_BUCKET,
        Key: key,
        Body: bytes,
        ContentType: mime
      })
    )

    return uploadRes.$metadata.httpStatusCode === 200
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getObject = async (formId: string) => {
  const thumbnailKey = `${formId}/thumbnail.jpeg`

  try {
    const uploadRes = await s3Client.send(
      new GetObjectCommand({
        Bucket: AWS_STORAGE_IMG_BUCKET,
        Key: thumbnailKey
      })
    )

    if (uploadRes.$metadata.httpStatusCode === 200) {
      const byteArray = await uploadRes.Body?.transformToByteArray()
      const blob = new Blob([byteArray as BlobPart])
      const url = URL.createObjectURL(blob)
      return url
    }
  } catch (error) {
    return 'no_key'
  }
}

export const deleteThumbnail = async (objectId: string) => {
  const thumbnailKey = `${objectId}/thumbnail.jpeg`
  deleteObject(thumbnailKey)
}

const deleteObject = async (key: string) => {
  try {
    const deleteRes = await s3Client.send(
      new DeleteObjectCommand({
        Bucket: AWS_STORAGE_IMG_BUCKET,
        Key: key
      })
    )

    return deleteRes.$metadata.httpStatusCode === 204
  } catch (error) {
    console.error(error)
  }
}
